import * as React from 'react';

function SvgStarFull(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.171 23.647a.684.684 0 01-.652-.898l1.986-6.121-5.222-3.796a.684.684 0 01.402-1.24h6.455l1.986-6.118a.685.685 0 011.304 0l1.985 6.118h6.454a.685.685 0 01.404 1.24l-5.223 3.796 1.987 6.121a.685.685 0 01-1.056.767l-5.203-3.782-5.204 3.781a.685.685 0 01-.403.132z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgStarFull;
